import React, { useState } from "react";
import CheckboxGroup from "antd/lib/checkbox/Group";
import { FormWrapperInputComponent } from "../Index";
import { TARGET_LANGUAGE_DATA } from "constants/Define";
import './AutoTranslate.less';

const AutoTranslate = (props) => {
    const { className, onChange = () => { }, languageCode, targetLanguage } = props;
    
    const [data, setData] = useState([]);

    const targetLanguageData = TARGET_LANGUAGE_DATA.filter(el => el.value !== languageCode);

    const onChangeTargetLanguage = (value) => {
        onChange('targetLanguage', value)
        return setData(value);
    };

    const ignoreTranslate = ["ko-KR", "zh-CN"];

    if (ignoreTranslate.includes(languageCode)) return <div />;

    return (
        <FormWrapperInputComponent
            className={`auto-translate-field ${className}`}
            labelTitle={"Lựa chọn thêm ngôn ngữ mong muốn được auto translate: "}
        >
            <CheckboxGroup
                options={
                    data.sourceLanguage === "en-US"
                        ? targetLanguageData.filter((item) => item.value !== "en-US")
                        : targetLanguageData
                }
                value={targetLanguage}
                onChange={(checkedValue) => onChangeTargetLanguage(checkedValue)}
            />
        </FormWrapperInputComponent>
    );
};

export default AutoTranslate;
